import React from 'react'
import { Outlet } from 'react-router-dom'

function MyTaskLayout() {
  return (
    <div>
       <div>
      <Outlet />
    </div>
    </div>
  )
}

export default MyTaskLayout
